import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { FarmacieService } from 'src/app/services/farmacie.service';
import { NotificationServiceService } from 'src/app/services/notification.service.service';

@Component({
  selector: 'app-centro-notifiche',
  templateUrl: './centro-notifiche.component.html',
  styleUrls: ['./centro-notifiche.component.css']
})
export class CentroNotificheComponent implements OnInit, OnDestroy {

  idShop;
  
  constructor(
    private notificatioService: NotificationServiceService,
    private farmacieService: FarmacieService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute) {

  };

  ngOnInit() {
    this.idShop = this.route.snapshot.paramMap.get("id");
  };

  signedAllNotifiedWithRead() {

  };

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
  }

}
